var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col divide-y"},_vm._l((_vm.randomInt()),function(i){return _c('div',{key:i,staticClass:"p-3"},[_vm._m(0,true),_vm._m(1,true)])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-3 mb-2 animate-pulse"},[_c('div',{staticClass:"h-full bg-gray-200 rounded"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-10 mb-2 animate-pulse"},[_c('div',{staticClass:"h-full bg-gray-200 rounded"})])
}]

export { render, staticRenderFns }